import { makeStyles } from "@material-ui/core";

const styles = makeStyles((theme) => ({
  incidentDatepicker: {
    width: 220,
    marginLeft: 40,

    // hack to hide the bold today cell, as the local date can be different from the domain's date
    // HvDatePicker doesn't allow to control or even style it
    "& div > div:nth-child(3) > div:nth-child(2) > div > button > p": {
      fontWeight: theme.hv.typography.normalText.fontWeight,
    },
  },
}));

export default styles;
